import MiscUtils, { DEV_STAGE, PROD_STAGE } from './MiscUtils'

const GCalConfig = {

  getClientId: () => {
    if (MiscUtils.STAGE === DEV_STAGE) {
      return '646196147370-1sf706f9kjsucu189p99ibt8scmhuk71.apps.googleusercontent.com'
    }
    else
    if (MiscUtils.STAGE === PROD_STAGE) {
      return '312610876770-vuuu9br4bku4bnbpiojjp4os0fjti2f6.apps.googleusercontent.com'
    }
  }

}

export default GCalConfig



// WEBPACK FOOTER //
// ./src/infra/GCalConfig.js